import { render, staticRenderFns } from "./ProductsListHeader.vue?vue&type=template&id=efe8c058&"
import script from "./ProductsListHeader.vue?vue&type=script&lang=js&"
export * from "./ProductsListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports